import React from "react";
import { Routes, Route } from "react-router-dom";
import paths from "./paths";

export default function R(props) {
  const {
    homePage: HomePage,
    aboutPage: AboutPage,
    portfolioPage: PortfolioPage,
    contactPage: ContactPage,
    termsPage: TermsPage,
    mediaRoom: MediaRoom,
    ourartPage: OurArtPage,
    homeMy: HomeMy,
    artistPage: ArtistPage,
    pricingPage: PricingPage,
    membershipPage: MembershipPage,
    shippingPage: ShippingPage,
    productsPage: ProductsPage,
    ProjectOne,
    ProjectTwo,
    ProjectThree,
    ProjectFour,
    Project,
  } = props;

  return (
    <Routes>
      <Route path={paths.home} element={<HomePage />} />
      <Route path={paths.about} element={<AboutPage />} />
      {MediaRoom && <Route path={paths.media} element={<MediaRoom />} />}
      {PortfolioPage && (
        <Route path={paths.portfolio} element={<PortfolioPage />} />
      )}
      {ContactPage && <Route path={paths.contact} element={<ContactPage />} />}
      {TermsPage && <Route path={paths.terms} element={<TermsPage />} />}
      {OurArtPage && <Route path={paths.ourart} element={<OurArtPage />} />}
      {HomeMy && <Route path={paths.homeMy} element={<HomeMy />} />}
      {ArtistPage && <Route path={paths.artist} element={<ArtistPage />} />}
      {PricingPage && <Route path={paths.pricing} element={<PricingPage />} />}
      {MembershipPage && (
        <Route path={paths.membership} element={<MembershipPage />} />
      )}
      {ShippingPage && (
        <Route path={paths.shipping} element={<ShippingPage />} />
      )}
      {ProductsPage && (
        <Route path={`${paths.products}/:id`} element={<ProductsPage />} />
      )}
      {ProjectOne && <Route path={paths.projects1} element={<ProjectOne />} />}
      {ProjectTwo && <Route path={paths.projects2} element={<ProjectTwo />} />}
      {ProjectThree && (
        <Route path={paths.projects3} element={<ProjectThree />} />
      )}
      {ProjectFour && (
        <Route path={paths.projects4} element={<ProjectFour />} />
      )}
      {Project && <Route path={paths.project} element={<Project />} />}
    </Routes>
  );
}
